export default __webpack_public_path__ + "6e75f8dbb2e9798a12e87e1bedc559ae.png";